const backgroundColor = [
  '#F9C180',
  '#F4E55B',
  '#36CFB3',
  '#5DA2F3',
  '#9BD4E0',
  '#C0B2CA',
]

export function configBarData(data) {
  if (!data) return { labels: [], datasets: [], max: 6, step: 1 }
  const labels = Object.keys(data)
  const firstValue = data[labels[0]]
  if (!firstValue) return { labels: [], datasets: [], max: 6, step: 1 }
  const keys = Object.keys(firstValue)

  const datasets = keys.map((k, i) => {
    return {
      axis: 'y',
      label: k,
      backgroundColor: backgroundColor[i],
      data: labels.map((el) => {
        return data[el][k]
      }),
    }
  })

  const max = keys.map((k, i) => {
    return labels.map((el) => {
      return data[el][k]
    })
  })

  // default settings
  let sugMax = 6
  let step = 1

  if (max.length > 0) {
    // transposition
    max[0].forEach((e) => {})
    const newMax = max[0]
      .map((e1, i) => {
        return max.map((e2) => e2[i])
      })
      .map((e3) => {
        return e3.reduce((prev, next) => prev + next, 0)
      })

    const m = Math.max(...newMax)

    if (m !== 0) {
      const num = parseFloat(m / 6)
      const int = Math.floor(num)
      const remain = m % 6

      if (remain !== 0) {
        sugMax = (int + 1) * 6
      } else {
        sugMax = int * 6
      }

      step = sugMax / 6
    }
  }

  return {
    labels,
    datasets,
    max: sugMax,
    step,
  }
}

export function configTableData(data) {
  const keys = Object.keys(data)
  const dataIndices = keys.length > 0 ? Object.keys(data[keys[0]]) : []
  const columns = configColumn(dataIndices)
  const dataSource = configDataSource(data)
  return { columns, dataSource }
}

function configColumn(data) {
  const fixedCol = [{ title: 'Title', dataIndex: 'Title', fixed: 'left' }]
  const cols = data.map((e) => ({
    title: e,
    dataIndex: e,
    className: `${e}`.replaceAll(' ', ''),
  }))
  return fixedCol.concat(cols)
}

function configDataSource(data) {
  return Object.keys(data).map((k) => {
    return { ...data[k], Title: k }
  })
}

export function configHeaderColor(data) {
  const ths = Array.from(
    document.getElementsByClassName('apply-table')[0].getElementsByTagName('th')
  )
  let mappingDic = {}
  Object.keys(data).forEach((e) => {
    mappingDic[e.replaceAll(' ', '')] = data[e]
  })
  ths.forEach((e) => {
    const clsNames = e.className.split(' ')
    if (clsNames.length > 1) {
      e.style.backgroundColor = mappingDic[clsNames[1]]
    }
  })
}
